<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        Partner Invoice Info
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">billing</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Invoice Partner</a>
        </li>
      </ul>
    </div>
    <div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card id="_share">
            <div class="d-flex flex-wrap align-items-center" v-if="is_show">
              <div class="title mr-auto mb7">
                Invoice Info
              </div>
              <div class="mb7">
                <b-button size="sm" class="float-right" variant="add" @click="share"> Export </b-button>
              </div>
            </div>
            <hr>
            <b-row>
              <vcl-facebook v-if="loading"></vcl-facebook>
              <b-col sm="12" v-else>
                <!-- here code from the template body start -->
                <body style="size: 21cm 29.7cm; background-color:white;">
                  <div id="body" style="margin: 10px; background-color:white;">
                    <center id="header" style="margin: 0px auto; width:80%;">
                      <img style="float: left;" src="F1-uwss.png" alt="partner logo" width="200">
                      <p style="text-decoration:underline; font-weight: bold; margin: 0; font-size: 80px; width: fit-content;">
                        INVOICE
                      </p>
                    </center>
  
                    <div style="margin-top:50px; text-align:center;">
                      <p style="text-align: right; width:88%; font-weight: bold; margin:0;">
                        Information Security Solution & Service Company
                      </p>
                      <div style="display:inline-block; width:40%; min-height: 350px; font-weight: bold;">
                        <table style="border-collapse: collapse; width:95%;">
                          <tbody>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%; background-color: gainsboro;">Payer Name </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.username || '-'}}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%; background-color: gainsboro;">Payer Address </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.address || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 60px; width:10%; background-color: gainsboro;">Invoice Number </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.invoice_id || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%; background-color: gainsboro;">Total Amount </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.total_price - model.total_partner_price }} {{ model.currency }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%; background-color: gainsboro;">Validity </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Within 4 weeks after estimated</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%; background-color: gainsboro;">Issue Date </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{  model.created_at | datetime }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
  
                      <div style="display:inline-block; width:40%; min-height:350px; font-weight: bold;">
                        <table style="border-collapse: collapse; width:95%; margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">Company Name </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;"> {{ model.bill_custom.company || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">Company Address </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">
                                {{ model.bill_custom.company_address || '-' }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 60px; background-color: gainsboro;">
                                Business Registration Number
                              </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">{{ model.bill_custom.business_number  || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;"> Issuer </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer  || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">Email </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer_email  || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;"> TEL </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.contact  || '-' }} </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <br>
  
                      <div style="display:inline-block; width:80%; text-align:left;">
                        <h2 style="padding-left: 15px;" v-if="model.start_at || model.end_at">
                          Billing period:  {{ model.start_at | date }} -  {{ model.end_at | date }}
                        </h2>
                        <h2 style="padding-left: 15px;" v-else>
                          Billing period:  -
                        </h2>
                        <p style="padding-left: 50px;">
                          Thank you for joining the partnership program with F1 Security, Inc.
                          <br>
                          We're writing to provide you with an electronic invoice for your end users of UWSS.
                          <br>
                          Additional information about this invoice, please access the partner console site and check the billing page.
                        </p>
                      </div>
                    </div>
                    <p style="text-align: right; width:90%; font-weight: bold; margin:0;">
                      ( {{ model.currency || '-' }} )
                    </p>
                    <div style="margin: 0 auto; text-align:center; font-weight: bold; width: 80%;">
                      <table style="border: 2px solid black; border-collapse: collapse; border-spacing: 0;">
                        <tr style="background-color: gainsboro; width:100%;">
                          <th style="padding: 5px; border: 2px solid black; width: 50%;">End User</th>
                          <th style="padding: 5px; border: 2px solid black; width: 18%;">Srv. Type</th>
                          <th style="padding: 5px; border: 2px solid black; width: 12%;">Quantity Used</th>
                          <th style="padding: 5px; border: 2px solid black; width: 18%;">Amount</th>
                          <th style="padding: 5px; border: 2px solid black; width: 5%;">REMARKS</th>
                        </tr>
                        <tr v-for="(x, id) in model.group_list_cache" v-bind:key="id">
                          <td style="padding: 5px; border-top: black solid 2px; width: 55%;"> {{ x.groupname }}</td>
                          <td style="border: black solid 2px; width: 18%;"> {{ x.service_name }}</td>
                          <td style="border: black solid 2px; width: 12%;"> {{ x.total_usage }}</td>
                          <!-- 에프원 제공 가격에서 파트너의 이익 뺀 가격임 -->
                          <td style="border: black solid 2px; width: 18%;"> {{ x.total_price - x.partner_price }}</td>
                          <td style="border: black solid 2px; width: 5%;">
                            {{ x.total_price == 0 ? '✓' : '' }}
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color: gainsboro; padding: 5px; border: black solid 2px; width: 78%;" colspan="3">Charges (Total)</td>
                          <td style="padding: 5px; border: black solid 2px; width: 18%;"> {{ model.total_price - model.total_partner_price }}</td>
                          <td style="padding: 5px; border: black solid 2px; width: 5%;">  VAT Included </td>
                        </tr>
                      </table>
                      <span style="float: left; padding-top:5px;">(*1) When calculating the daily usage fee, one month is 30 days</span>
                      <br>
                      <div style="margin-top:50px;" v-if="model.bill_custom">
                        <span style="float:left">Payment Means: Please, pay to F1 Security Inc.’s designated Bank account</span>
                        <table style="border: 2px solid black; border-collapse: collapse; border-spacing: 0; width: 100%;">
                          <tr>
                            <th style="padding: 5px; border: 2px solid black; width: 15%; background-color: gainsboro;">Bank Name</th>
                            <th style="padding: 5px; border: 2px solid black; width: 45%;"> {{ model.bill_custom.bank_name || '-' }} </th>
                            <th style="padding: 5px; border: 2px solid black; width: 20%; background-color: gainsboro;">  Swift Code </th>
                            <th style="padding: 5px; border: 2px solid black; width: 20%;"> {{ model.bill_custom.swift_code || '-' }} </th>
                          </tr>
                          <tr>
                            <td style="border: black solid 2px; width: 15%; background-color: gainsboro;"> Account No. </td>
                            <td style="border: black solid 2px; width: 45%;"> {{ model.bill_custom.bank_number }}</td>
                            <td style="border: black solid 2px; width: 20%; background-color: gainsboro;">  Account Holder </td>
                            <td style="border: black solid 2px; width: 20%;"> {{ model.bill_custom.account_holder || '-' }} </td>
                          </tr>
                          <tr>
                            <td style="padding: 5px; border-top: black solid 2px; width: 15%; background-color: gainsboro;"> Bank branch </td>
                            <td style="border: black solid 2px;" colspan="3"> {{ model.bill_custom.bank_branch || '-' }} </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div id="footer">
                    <img style="float:right; margin-top:50px;" :src="model.logo" alt="partner logo" width="200" v-if="model.logo">
                    <img style="float:right; margin-top:50px; margin-right:10%;" src="img/F1security.png" alt="partner logo" width="200" v-else>
                  </div>
                </body>
                <!-- here code from the template body end  -->
              </b-col>
            </b-row>
          </b-card>
          <b-card id="_share">
            <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
            <b-row v-if="!loading">
              <b-col md="12">
                <label class="col-form-label" for=""><h4>Partial Payment History</h4></label>
              </b-col>
              <b-col md="12">
                <!-- TODO : 테이블로 예쁘게 해야 함 -->
                <ul class="list-group">
                  <li class="list-group-item" v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300 }">
                    <small v-if="item && item.payer">
                      <!-- paypal -->
                      [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                      [Company:{{item.payer.email_address}}]
                      [Action:{{item.purchase_units[0].description}}]
                      [Method:{{item.pg}}]
                      [Price:{{item.purchase_units[0].amount.value}}]
                      [Currenty:{{item.purchase_units[0].amount.currency_code}}]
                      [Country:{{item.payer.address.country_code}}]
                    </small>
                    <small v-else>
                      <!-- boot_pay or credit -->
                      [Purchased Date:{{item.purchased_at | datetime}}]
                      [Company:{{item.pg_name}}]
                      [Action:{{item.action}}]
                      [Method:{{item.pg}}]
                      [Price:{{item.price}}]
                      [Currenty:{{'KRW'}}]
                      [Country:{{'KR'}}]
                    </small>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <hr v-if="is_show">
            <b-button v-if="is_show" :disabled="model.is_paid" class="float-left m-1" size="sm" variant="outline-primary" @click="is_pay = true; model.pay_price = model.total_price"> Manual Payment </b-button>
            <b-button v-if="is_show" size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-card>
        </b-col>
      </b-row>
  
      <router-view></router-view>
      <!-- modal area -->
      <b-modal title="Manual Payment" header-bg-variant="warning" v-model="is_pay" @ok="pay" ok-variant="outline-warning" cancel-variant="outline-dark">
        <!-- <b-checkbox class="ml-3 mt-1" v-model="use_system_credit">Use System Credit (default using partner's credit)</b-checkbox>
        <hr> -->
        <!-- <span> -->
          <!-- Payment can be made with partner's credit or system's credit -->
          <!-- Payment by partner's credit
        </span>
        <hr> -->
        <b-form-input md=12 type="text" id="ph_name" v-model="model.pay_price" ></b-form-input>
      </b-modal>
    </div>
    </div>
  </template>
  
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>